import { ApiProviderProps, ApiContext } from './ApiContext';

// The host app owns the api instance (its services/api.config.ts) and injects it here.
// shared never constructs its own instance and never reads import.meta.env.
export default function ApiProvider({ api, children }: ApiProviderProps) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}
